import {
  FormControlLabel,
  RadioGroup as MuiRadioGroup,
  Radio as MuiRadio,
  Stack
} from '@mui/material';
import { FieldProps, RadioFieldSchema } from '../types/Form';
import { FieldWrapper } from './FieldWrapper';

export const RadioGroup: React.FC<FieldProps<RadioFieldSchema>> = ({
  name,
  value,
  field,
  errorMessage,
  onChange
}) => {
  const { label, subLabel, containerSx, isLoading, ...restField } = field;

  return (
    <FieldWrapper
      label={label}
      subLabel={subLabel}
      errorMessage={errorMessage}
      sx={containerSx}
      isLoading={isLoading}
    >
      <MuiRadioGroup
        data-testid={`radio-group-${name}`}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        sx={{
          gap: '15px'
        }}
        {...restField}
      >
        {field.options.map((option) => (
          <Stack
            key={option.value}
            direction="row"
            alignItems={option.alignItems ?? 'center'}
          >
            <FormControlLabel
              sx={{
                color: 'customGrey.dark',
                marginLeft: 0,
                marginRight: 2,
                alignItems: option.alignItems ?? 'center',
                '& > .MuiTypography-root': {
                  marginLeft: '8px'
                }
              }}
              value={option.value}
              control={
                <MuiRadio
                  sx={{
                    padding: 0,
                    width: '25px',
                    height: '25px',
                    '& .MuiSvgIcon-root': {
                      width: '25px',
                      height: '25px'
                    }
                  }}
                  disabled={option.disabled}
                />
              }
              label={option.label}
            />
            {option.endItem}
          </Stack>
        ))}
      </MuiRadioGroup>
    </FieldWrapper>
  );
};
